import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_PLAYERS_QUERY_KEY } from '@/state/queries/players/use-get-players';
import { GET_AV_SOURCES_QUERY_KEY } from '@/state/queries/players/use-get-av-sources';
import { GET_SPACE_PLAYER_SETUP_QUERY_KEY } from '@/state/queries/players/use-get-space-player-setup';

export const useDeletePlayerMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (playerId: string) => {
      const token = await getToken();
      return deletePlayer(playerId, token ?? '');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_PLAYERS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_AV_SOURCES_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [GET_SPACE_PLAYER_SETUP_QUERY_KEY] });
    },
  });
};

const deletePlayer = async (playerId: string, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/player/${playerId}`;
  return sendJSONRequest({ url, method: METHOD.DELETE, token });
};
